<template>
  <div>
    <h4><i class="fas fa-user"></i> Electoral Roll</h4>
    <b-table :items="electoralroll" :fields="['electoral_number', 'authority', 'first_name', 'dob', 'address_line_1', 'uprn']">
      <template #head(first_name)>Name</template>
      <template #cell(electoral_number)="data"><code>{{ data.value }}</code></template>
      <template #cell(first_name)="data">{{ data.value }} {{ data.item.last_name }}</template>
      <template #cell(dob)="data">{{ data.value || 'Not held' }}</template>
      <template #cell(authority)="data"><authority :authority="data.value"/></template>
    </b-table>
  </div>
</template>

<script>
import Authority from '../Authority.vue'

export default {
  components: { Authority },
  props: ['electoralroll'],
};
</script>

